import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const CrewBoatPrivacyPolicy = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Minimal sticky nav */}
      <div style={{ background: '#1e3c72', padding: '12px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', position: 'sticky', top: 0, zIndex: 100 }}>
        <button onClick={() => navigate('/crewboat')} style={{ background: 'none', border: 'none', color: '#93c5fd', fontSize: '14px', cursor: 'pointer', fontWeight: 600, padding: 0 }}>← CrewBoat</button>
        <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
          <Link to="/crewboat/terms" style={{ color: '#93c5fd', textDecoration: 'none', fontSize: '13px' }}>📋 Termini</Link>
          <Link to="/" style={{ color: '#93c5fd', textDecoration: 'none', fontSize: '13px' }}>🏠 VMDProject</Link>
        </div>
      </div>
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        padding: '20px',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        lineHeight: 1.6,
        color: '#333',
      }}
    >
      <div
        style={{
          maxWidth: '900px',
          margin: '0 auto',
          background: 'white',
          borderRadius: '15px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <div
          style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            color: 'white',
            padding: '40px',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              width: '64px',
              height: '64px',
              margin: '0 auto 16px',
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '30px',
            }}
          >
            🛡️
          </div>
          <h1
            style={{
              fontSize: '2.5rem',
              fontWeight: 'bold',
              marginBottom: '10px',
            }}
          >
            Privacy Policy
          </h1>
          <p style={{ fontSize: '1.2rem', opacity: 0.9 }}>
            CrewBoat - Maritime Operations Management
          </p>
          <p style={{ fontSize: '1rem', opacity: 0.8, marginTop: '10px' }}>
            Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
          </p>
        </div>

        {/* Content */}
        <div style={{ padding: '40px' }}>
          <section style={{ marginBottom: '40px' }}>
            <p
              style={{
                fontSize: '1.1rem',
                marginBottom: '20px',
                color: '#666',
              }}
            >
              Questa informativa viene espressa come previsto dal D.lgs.
              196/2003 (Codice in materia di protezione dei dati personali)
              ("Codice Privacy") e del Regolamento UE 679/2016 - Regolamento
              Generale sulla Protezione dei Dati Personali ("GDPR") e dai
              Provvedimenti del Garante per la privacy relativi all'utilizzo di
              cookie, in attuazione alle direttive europee.
            </p>
            <p style={{ fontSize: '1.1rem', color: '#666' }}>
              Di seguito vengono descritte le modalità di gestione dei dati
              relativi agli utenti che interagiscono con l'applicazione CrewBoat
              per la gestione delle operazioni marittime, scaricabile attraverso
              gli store Google Play ed App Store. L'informativa è da intendersi
              quale Informativa resa ai sensi dell'art. 13 della Normativa
              Applicabile a coloro che interagiscono con l'applicazione mobile e
              si intende limitata alla navigazione su tale app mentre non si
              applica ad altri siti web eventualmente consultati tramite link
              esterni.
            </p>
          </section>

          {/* Titolare del Trattamento */}
          <section style={{ marginBottom: '40px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '20px',
              }}
            >
              <div
                style={{
                  width: '24px',
                  height: '24px',
                  marginRight: '12px',
                  color: '#2563eb',
                  fontSize: '20px',
                }}
              >
                👥
              </div>
              <h2
                style={{
                  fontSize: '1.8rem',
                  fontWeight: 'bold',
                  color: '#1e3c72',
                  margin: 0,
                }}
              >
                Titolare del Trattamento dei Dati
              </h2>
            </div>
            <div
              style={{
                background: '#f8f9fa',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #e9ecef',
              }}
            >
              <p>
                <strong>VMDProject</strong>
              </p>
              <p>Indirizzo email del Titolare: vmdpproject@gmail.com</p>
              <p style={{ marginTop: '15px', fontSize: '0.95rem' }}>
                VMDProject adotta le opportune misure di sicurezza volte ad
                impedire l'accesso, la divulgazione, la modifica o la
                distruzione non autorizzate dei Dati Personali. Il trattamento
                viene effettuato mediante strumenti informatici e/o telematici,
                con modalità organizzative e con logiche strettamente correlate
                alle finalità indicate.
              </p>
            </div>
          </section>

          {/* Oggetto del Trattamento */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Oggetto del Trattamento
            </h2>
            <div
              style={{
                background: '#f0f8ff',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #bde0ff',
              }}
            >
              <p>
                A seguito della consultazione di questa app possono essere
                trattati dati relativi a persone identificate o identificabili.
                I dati personali sono trattati in occasione dell'utilizzo
                dell'app da parte dell'utente per la gestione delle operazioni
                marittime e la conformità alle normative internazionali del
                settore.
              </p>
            </div>
          </section>

          {/* Informazioni Raccolte */}
          <section style={{ marginBottom: '40px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '20px',
              }}
            >
              <div
                style={{
                  width: '24px',
                  height: '24px',
                  marginRight: '12px',
                  color: '#2563eb',
                  fontSize: '20px',
                }}
              >
                💾
              </div>
              <h2
                style={{
                  fontSize: '1.8rem',
                  fontWeight: 'bold',
                  color: '#1e3c72',
                  margin: 0,
                }}
              >
                Informazioni che Raccogliamo
              </h2>
            </div>

            <div
              style={{
                display: 'grid',
                gap: '20px',
                gridTemplateColumns: '1fr',
                marginBottom: '25px',
              }}
            >
              <div
                style={{
                  background: '#fff5f5',
                  padding: '20px',
                  borderRadius: '10px',
                  border: '1px solid #fed7d7',
                }}
              >
                <h3 style={{ color: '#c53030', marginBottom: '10px' }}>
                  Dati Professionali dell'Equipaggio
                </h3>
                <p>
                  Nome, cognome, ruolo a bordo, certificazioni STCW, esperienze
                  lavorative, competenze specialistiche, informazioni di
                  contatto di emergenza, dettagli contratto di lavoro, documenti
                  di identificazione necessari per l'imbarco.
                </p>
              </div>

              <div
                style={{
                  background: '#f0fff4',
                  padding: '20px',
                  borderRadius: '10px',
                  border: '1px solid #c6f6d5',
                }}
              >
                <h3 style={{ color: '#38a169', marginBottom: '10px' }}>
                  Dati Operativi dell'Imbarcazione
                </h3>
                <p>
                  Informazioni sull'imbarcazione, inventario e magazzino, piani
                  di manutenzione, documentazione tecnica, turni di lavoro,
                  comunicazioni interne, log delle operazioni marittime, dati di
                  navigazione e posizionamento GPS.
                </p>
              </div>

              <div
                style={{
                  background: '#fffaf0',
                  padding: '20px',
                  borderRadius: '10px',
                  border: '1px solid #fbd38d',
                }}
              >
                <h3 style={{ color: '#d69e2e', marginBottom: '10px' }}>
                  Dati Tecnici e di Navigazione
                </h3>
                <p>
                  Dati di registro e utilizzo dell'app, informazioni sul
                  dispositivo, indirizzo IP, numeri di identificazione del
                  dispositivo, posizione geografica dell'imbarcazione, sistema
                  operativo, dati di connettività, log di accesso e utilizzo
                  delle funzionalità.
                </p>
              </div>
            </div>

            <div
              style={{
                background: '#f8f9fa',
                padding: '15px',
                borderRadius: '8px',
                border: '1px solid #dee2e6',
              }}
            >
              <h4 style={{ color: '#495057', marginBottom: '10px' }}>
                Informazioni Raccolte Automaticamente:
              </h4>
              <p style={{ fontSize: '0.95rem', margin: 0 }}>
                Dati di registro e utilizzo dell'applicazione, informazioni
                diagnostiche e sulle prestazioni, dati del dispositivo mobile
                inclusi indirizzo IP, identificativi unici, informazioni sul
                sistema operativo e configurazione del dispositivo, dati di
                geolocalizzazione per le funzioni di tracking delle
                imbarcazioni.
              </p>
            </div>
          </section>

          {/* Finalità del Trattamento */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Finalità del Trattamento
            </h2>

            <p
              style={{ marginBottom: '20px', fontSize: '1rem', color: '#666' }}
            >
              Il trattamento dei dati personali di coloro che utilizzeranno
              l'app CrewBoat avverrà per finalità differenti a seconda delle
              categorie di dati trattati e delle funzionalità utilizzate:
            </p>

            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  marginBottom: '15px',
                  padding: '15px',
                  background: '#f8f9fa',
                  borderRadius: '5px',
                }}
              >
                <span
                  style={{
                    color: '#28a745',
                    marginRight: '15px',
                    fontSize: '1.2rem',
                    marginTop: '2px',
                  }}
                >
                  ✓
                </span>
                <div>
                  <strong>Gestione Operazioni Marittime:</strong> Coordinamento
                  equipaggio, pianificazione turni di lavoro, gestione
                  inventario e magazzino, monitoraggio delle attività operative
                  quotidiane, tracciamento delle certificazioni e competenze del
                  personale.
                </div>
              </li>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  marginBottom: '15px',
                  padding: '15px',
                  background: '#f8f9fa',
                  borderRadius: '5px',
                }}
              >
                <span
                  style={{
                    color: '#28a745',
                    marginRight: '15px',
                    fontSize: '1.2rem',
                    marginTop: '2px',
                  }}
                >
                  ✓
                </span>
                <div>
                  <strong>Compliance Normativa:</strong> Conformità alle
                  convenzioni internazionali SOLAS (Safety of Life at Sea),
                  MARPOL (prevenzione inquinamento marino), STCW (Standards of
                  Training), MLC 2006 (Maritime Labour Convention), ISM Code
                  (International Safety Management), ISPS Code (International
                  Ship and Port Facility Security).
                </div>
              </li>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  marginBottom: '15px',
                  padding: '15px',
                  background: '#f8f9fa',
                  borderRadius: '5px',
                }}
              >
                <span
                  style={{
                    color: '#28a745',
                    marginRight: '15px',
                    fontSize: '1.2rem',
                    marginTop: '2px',
                  }}
                >
                  ✓
                </span>
                <div>
                  <strong>Sicurezza e Manutenzione:</strong> Programmazione e
                  tracciamento delle manutenzioni preventive e correttive,
                  gestione delle emergenze e procedure di sicurezza,
                  documentazione degli incidenti e near-miss, controllo degli
                  accessi alle aree sensibili dell'imbarcazione.
                </div>
              </li>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  marginBottom: '15px',
                  padding: '15px',
                  background: '#f8f9fa',
                  borderRadius: '5px',
                }}
              >
                <span
                  style={{
                    color: '#28a745',
                    marginRight: '15px',
                    fontSize: '1.2rem',
                    marginTop: '2px',
                  }}
                >
                  ✓
                </span>
                <div>
                  <strong>Comunicazione Interna:</strong> Sistema di
                  messaggistica sicura tra membri dell'equipaggio, notifiche
                  operative urgenti, condivisione di documenti tecnici e
                  procedure operative, coordinamento delle attività tra i
                  diversi reparti dell'imbarcazione.
                </div>
              </li>
            </ul>
          </section>

          {/* Base Giuridica */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Base Giuridica del Trattamento
            </h2>
            <div
              style={{
                background: '#fff3cd',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #ffeaa7',
              }}
            >
              <p>
                La base giuridica per il trattamento dei dati di navigazione
                risiede nell'interesse legittimo del Titolare del Trattamento ad
                un'efficiente e sicura navigazione sull'applicazione, anche di
                natura interattiva, in base a quanto sancito dall'art. 6, par.
                1, lett. f) GDPR. Per i dati forniti volontariamente
                dall'utente, la base giuridica è rinvenibile nel consenso
                espresso dall'interessato ex art. 6, par. 1, lett. a) ed art. 9,
                par. 2, lett. a) GDPR.
              </p>
              <p style={{ marginTop: '15px' }}>
                Con l'uso o la consultazione della presente app, i visitatori e
                gli utenti approvano esplicitamente le informazioni privacy e
                acconsentono al trattamento dei loro dati personali in relazione
                alle modalità e alle finalità sopra descritte. Il conferimento
                dei dati e quindi il consenso alla raccolta e al trattamento
                sono facoltativi, l'Utente può negare il consenso e può revocare
                in qualsiasi momento un consenso già fornito.
              </p>
            </div>
          </section>

          {/* Modalità di Trattamento */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Modalità e Luogo del Trattamento
            </h2>
            <div
              style={{
                background: '#f3e5f5',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #ce93d8',
              }}
            >
              <p>
                Il trattamento dei dati personali raccolti è realizzato secondo
                le indicazioni dell'art. 4, par. 1, n. 2 GDPR: raccolta,
                registrazione, organizzazione, conservazione, consultazione,
                elaborazione, modificazione, selezione, estrazione, raffronto,
                utilizzo, interconnessione, blocco, comunicazione, cancellazione
                e distruzione dei dati.
              </p>
              <p style={{ marginTop: '15px' }}>
                I dati personali e di navigazione sono trattati in forma
                elettronica per i tempi necessari a portare a termine gli scopi
                per cui sono stati raccolti. Sono osservate specifiche misure di
                sicurezza, come previsto dalla normativa, per prevenire la loro
                perdita, usi illeciti e non consentiti e accessi non
                autorizzati.
              </p>
            </div>
          </section>

          {/* Sicurezza dei Dati */}
          <section style={{ marginBottom: '40px' }}>
            <div
              style={{
                background: '#e6fffa',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #81e6d9',
              }}
            >
              <h3 style={{ color: '#234e52', marginBottom: '15px' }}>
                🔒 Sicurezza e Protezione dei Dati
              </h3>
              <p style={{ marginBottom: '15px' }}>
                Implementiamo misure tecniche e organizzative avanzate per
                garantire un livello di sicurezza adeguato al rischio derivante
                dal trattamento dei dati nel settore marittimo:
              </p>
              <ul>
                <li>
                  <strong>Crittografia AES-256:</strong> Tutti i dati sono
                  crittografati in transito e a riposo con standard militari
                </li>
                <li>
                  <strong>Autenticazione Multi-Fattore:</strong> Protezione
                  avanzata per account sensibili del personale di bordo
                </li>
                <li>
                  <strong>Controllo Accessi Granulare:</strong> Permessi basati
                  su ruoli e responsabilità specifiche a bordo dell'imbarcazione
                </li>
                <li>
                  <strong>Backup Automatici:</strong> Backup incrementali ogni 6
                  ore con retention sicura e ripristino rapido
                </li>
                <li>
                  <strong>Operatività Offline Sicura:</strong> Sincronizzazione
                  sicura in condizioni di connettività limitata tipiche
                  dell'ambiente marino
                </li>
                <li>
                  <strong>Monitoraggio Continuo:</strong> Sistema di rilevamento
                  intrusioni e monitoraggio delle attività sospette 24/7
                </li>
              </ul>
            </div>
          </section>

          {/* Conformità Normative */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Conformità Normative Marittime
            </h2>

            <p style={{ marginBottom: '20px' }}>
              CrewBoat è progettato per supportare la conformità alle principali
              normative marittime internazionali e garantire il rispetto degli
              standard più elevati del settore:
            </p>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                gap: '15px',
                marginBottom: '20px',
              }}
            >
              {[
                'IMO SOLAS',
                'MARPOL',
                'STCW',
                'MLC 2006',
                'ISM Code',
                'ISPS Code',
              ].map((norm, index) => (
                <div
                  key={index}
                  style={{
                    background:
                      'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    padding: '12px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                  }}
                >
                  {norm}
                </div>
              ))}
            </div>

            <div
              style={{
                background: '#e8f4fd',
                padding: '15px',
                borderRadius: '8px',
                border: '1px solid #bee5eb',
              }}
            >
              <p style={{ fontSize: '0.95rem', margin: 0 }}>
                <strong>Nota importante:</strong> I periodi di conservazione dei
                dati rispettano i requisiti delle convenzioni marittime
                internazionali e possono variare in base alla bandiera
                dell'imbarcazione e alle normative locali del porto di
                registrazione.
              </p>
            </div>
          </section>

          {/* Comunicazione e Diffusione */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Comunicazione e Diffusione dei Dati
            </h2>
            <div
              style={{
                background: '#f8f9fa',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #e9ecef',
              }}
            >
              <p>
                I dati di navigazione non sono diffusi né comunicati a soggetti
                esterni salvo quanto previsto dalla legge. I dati personali
                raccolti attraverso l'applicazione vengono comunicati a terzi
                solo se strettamente necessario ai fini della gestione delle
                operazioni marittime e della sicurezza dell'imbarcazione.
              </p>
              <p style={{ marginTop: '15px' }}>
                Il fornitore del servizio di hosting e le piattaforme cloud
                utilizzate possono avere accesso ai dati esclusivamente per
                ragioni tecniche di necessità ed urgenza che richiedano un
                intervento per non pregiudicare le funzionalità e la sicurezza
                del sistema.
              </p>
            </div>
          </section>

          {/* Diritti dell'Interessato */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Diritti dell'Interessato (GDPR)
            </h2>

            <div
              style={{
                background: '#fff3cd',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #ffeaa7',
                marginBottom: '20px',
              }}
            >
              <p>
                <strong>
                  Secondo il GDPR, ogni membro dell'equipaggio e utilizzatore
                  dell'app dispone dei seguenti diritti fondamentali:
                </strong>
              </p>
            </div>

            <div style={{ display: 'grid', gap: '15px' }}>
              {[
                {
                  title: 'Diritto di Accesso',
                  desc: 'Richiedere informazioni sui propri dati personali trattati e ottenere copia degli stessi',
                },
                {
                  title: 'Diritto di Rettifica',
                  desc: 'Correggere dati inesatti o integrare quelli incompleti relativi al proprio profilo professionale',
                },
                {
                  title: 'Diritto di Cancellazione',
                  desc: 'Richiedere la cancellazione dei propri dati quando non più necessari ("diritto all\'oblio")',
                },
                {
                  title: 'Diritto di Limitazione',
                  desc: 'Ottenere la limitazione del trattamento in specifiche circostanze previste dalla legge',
                },
                {
                  title: 'Diritto alla Portabilità',
                  desc: 'Ricevere i propri dati in formato strutturato e trasferirli ad altro titolare',
                },
                {
                  title: 'Diritto di Opposizione',
                  desc: 'Opporsi al trattamento per motivi legittimi relativi alla propria situazione particolare',
                },
              ].map((right, index) => (
                <div
                  key={index}
                  style={{
                    background: '#f8f9fa',
                    padding: '15px',
                    borderRadius: '8px',
                    border: '1px solid #dee2e6',
                  }}
                >
                  <h4
                    style={{
                      color: '#1e3c72',
                      marginBottom: '8px',
                      fontSize: '1.1rem',
                    }}
                  >
                    {right.title}
                  </h4>
                  <p style={{ margin: 0, fontSize: '0.95rem' }}>{right.desc}</p>
                </div>
              ))}
            </div>

            <div
              style={{
                background: '#d4edda',
                padding: '15px',
                borderRadius: '8px',
                border: '1px solid #c3e6cb',
                marginTop: '20px',
              }}
            >
              <p style={{ margin: 0, fontSize: '0.95rem' }}>
                <strong>Come esercitare i tuoi diritti:</strong> Per esercitare
                qualsiasi diritto sopra elencato, è possibile contattare il
                Titolare del trattamento all'indirizzo vmdpproject@gmail.com
                specificando nell'oggetto "CrewBoat - Richiesta Privacy" e la
                natura della richiesta.
              </p>
            </div>
          </section>

          {/* Conservazione */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Conservazione dei Dati
            </h2>

            <div
              style={{
                background: '#f3e5f5',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #ce93d8',
              }}
            >
              <p>
                <strong>
                  Periodi di Conservazione Specifici per Settore Marittimo:
                </strong>
              </p>
              <ul style={{ marginTop: '15px' }}>
                <li>
                  <strong>Dati Operativi:</strong> Durante il periodo di
                  servizio a bordo dell'imbarcazione
                </li>
                <li>
                  <strong>Dati di Compliance e Certificazioni:</strong> Secondo
                  i requisiti normativi marittimi internazionali (tipicamente
                  5-10 anni dalla cessazione del servizio)
                </li>
                <li>
                  <strong>Log di Sicurezza e Audit Trail:</strong> 12 mesi per
                  controlli di sicurezza e conformità normativa
                </li>
                <li>
                  <strong>Dati di Navigazione e Posizionamento:</strong> 24 mesi
                  o fino a richiesta di cancellazione da parte dell'interessato
                </li>
                <li>
                  <strong>Documentazione di Emergenza:</strong> Conservati
                  secondo le prescrizioni dell'Autorità Marittima competente
                </li>
                <li>
                  <strong>Dati Contrattuali:</strong> Per il periodo di durata
                  del contratto e successivamente per il tempo previsto da
                  obblighi fiscali e legali
                </li>
              </ul>
              <p style={{ marginTop: '15px', fontSize: '0.9rem' }}>
                <strong>Nota importante:</strong> I periodi di conservazione
                rispettano rigorosamente i requisiti delle convenzioni marittime
                internazionali (IMO, ILO) e possono variare in base alla
                bandiera dell'imbarcazione, alle normative del porto di
                registrazione e agli accordi contrattuali specifici del settore
                marittimo.
              </p>
            </div>
          </section>

          {/* Trasferimento Dati */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Trasferimento dei Dati Personali
            </h2>
            <div
              style={{
                background: '#fff5f5',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #fed7d7',
              }}
            >
              <p>
                Le attività di trattamento dei dati personali sono svolte e
                gestite prevalentemente in house senza il coinvolgimento di
                soggetti esterni all'azienda responsabile. Il Titolare del
                trattamento si riserva la possibilità di comunicare i dati verso
                terzi operatori e/o fornitori ai fini del perseguimento delle
                finalità sopra indicate o quando richiesto dalle Istituzioni o
                dalle Autorità giurisdizionali.
              </p>
              <p style={{ marginTop: '15px' }}>
                L'eventuale trasferimento dei dati personali a un Paese terzo o
                ad un'Organizzazione internazionale avverrà, anche alla luce
                della Sentenza Schrems della CGUE, alla sola condizione che
                abbiano ottenuto accertamento positivo degli standard di tutela
                tramite decisione di adeguatezza da parte della Commissione
                Europea ex art. 45 GDPR o, in alternativa, siano riconosciute
                garanzie adeguate ex art. 46 GDPR.
              </p>
            </div>
          </section>

          {/* Accesso ai Dati */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Accesso ai Dati Personali
            </h2>
            <div
              style={{
                background: '#e8f4fd',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #bee5eb',
              }}
            >
              <p>
                Per le finalità sopra descritte, i dati personali potranno
                essere accessibili a:
              </p>
              <ul style={{ marginTop: '15px' }}>
                <li>
                  Collaboratori del Titolare nella loro qualità di persone
                  autorizzate al trattamento e/o amministratori di sistema
                </li>
                <li>
                  Società terze che svolgono attività in outsourcing per conto
                  del Titolare nella loro qualità di Responsabili del
                  trattamento ex art. 28 GDPR
                </li>
                <li>
                  Soggetti che elaborano i dati in esecuzione di specifici
                  obblighi di legge
                </li>
                <li>
                  Autorità giudiziarie, marittime o amministrative, per
                  l'adempimento degli obblighi di legge e normative del settore
                  navale
                </li>
                <li>
                  Società di classificazione navale e organismi di
                  certificazione marittima quando richiesto per conformità
                  normativa
                </li>
              </ul>
            </div>
          </section>

          {/* Conseguenze Mancata Comunicazione */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Conseguenze della Mancata Comunicazione dei Dati
            </h2>
            <div
              style={{
                background: '#fff3cd',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #ffeaa7',
              }}
            >
              <p>
                Con riguardo ai dati personali relativi all'esecuzione del
                contratto di imbarco o relativi all'adempimento ad un obbligo
                normativo marittimo (ad esempio gli adempimenti legati alle
                certificazioni STCW, alla tenuta dei registri di bordo), la
                mancata comunicazione dei dati personali impedisce il
                perfezionarsi del rapporto contrattuale stesso e la conformità
                alle normative internazionali del settore marittimo.
              </p>
              <p style={{ marginTop: '15px' }}>
                Per quanto riguarda la navigazione nell'app, non è richiesta la
                comunicazione di dati personali specifici, ma implica la
                rilevazione di dati anonimi di utilizzo necessari per il
                funzionamento delle funzionalità operative.
              </p>
            </div>
          </section>

          {/* Contatti Privacy */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Contatti per Privacy e Diritti GDPR
            </h2>

            <div
              style={{
                background: '#e3f2fd',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #90caf9',
              }}
            >
              <p>
                <strong>
                  Per esercitare i tuoi diritti o per informazioni sulla
                  privacy:
                </strong>
              </p>
              <p>
                <strong>Titolare del trattamento:</strong> VMDProject
              </p>
              <p>
                Email:{' '}
                <a
                  href="mailto:vmdpproject@gmail.com"
                  style={{ color: '#1e3c72' }}
                >
                  vmdpproject@gmail.com
                </a>
              </p>
              <p>Oggetto: "CrewBoat - Richiesta Privacy"</p>
              <p style={{ marginTop: '15px', fontSize: '0.95rem' }}>
                <strong>Diritto di reclamo:</strong> È possibile proporre
                reclamo all'Autorità Garante per la protezione dei dati
                personali (www.garanteprivacy.it) secondo quanto previsto
                dall'art. 77 GDPR.
              </p>
            </div>
          </section>

          {/* Modifiche Policy */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Modifiche alla Presente Policy
            </h2>
            <div
              style={{
                background: '#f8f9fa',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #e9ecef',
              }}
            >
              <p>
                Le condizioni della presente Informativa possono cambiare di
                volta in volta per adeguarsi a evoluzioni normative o
                tecnologiche. Pubblicheremo eventuali modifiche sostanziali alla
                presente Informativa mediante debita comunicazione attraverso
                l'applicazione o contattando l'utente tramite altri canali
                disponibili.
              </p>
              <p style={{ marginTop: '15px' }}>
                Si raccomanda di consultare periodicamente questa sezione per
                rimanere aggiornati sulle modalità di trattamento dei dati
                personali.
              </p>
            </div>
          </section>

          {/* Sezione Educativa GDPR */}
          <section style={{ marginBottom: '40px' }}>
            <div
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
              }}
            >
              <h2 style={{ fontSize: '2rem', marginBottom: '15px' }}>
                🛡️ PROTEZIONE DEI DATI
              </h2>
              <p style={{ fontSize: '1.1rem', opacity: 0.9 }}>
                Il GDPR e il Codice Privacy nel Settore Marittimo
              </p>
            </div>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Il GDPR e il Codice Privacy
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Il diritto alla protezione dei dati personali è un diritto
              fondamentale dell'individuo tutelato dal Regolamento (UE) 2016/679
              del Parlamento europeo e del Consiglio, del 27 aprile 2016,
              relativo alla protezione delle persone fisiche con riguardo al
              trattamento dei dati personali.
            </p>
            <p>
              In Italia il Codice Privacy è stato novellato a seguito
              dell'entrata in vigore del Regolamento con il D.lgs. 101/2018,
              strumento normativo attraverso il quale sono stati inserite le
              principali innovazioni proposte in tema di trattamento dei dati
              personali da parte del Legislatore europeo. Nel settore marittimo,
              queste normative si integrano con le convenzioni internazionali
              IMO e ILO.
            </p>
          </section>

          {/* Definizioni */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Definizioni Fondamentali
            </h2>
            <div style={{ display: 'grid', gap: '15px' }}>
              <div
                style={{
                  background: '#f8f9fa',
                  padding: '15px',
                  borderRadius: '8px',
                  border: '1px solid #dee2e6',
                }}
              >
                <h4 style={{ color: '#1e3c72', marginBottom: '8px' }}>
                  Dato Personale
                </h4>
                <p style={{ margin: 0, fontSize: '0.95rem' }}>
                  Qualsiasi informazione riguardante una persona fisica
                  identificata o identificabile ("interessato"); si considera
                  identificabile la persona fisica che può essere identificata,
                  direttamente o indirettamente.
                </p>
              </div>
              <div
                style={{
                  background: '#f8f9fa',
                  padding: '15px',
                  borderRadius: '8px',
                  border: '1px solid #dee2e6',
                }}
              >
                <h4 style={{ color: '#1e3c72', marginBottom: '8px' }}>
                  Trattamento
                </h4>
                <p style={{ margin: 0, fontSize: '0.95rem' }}>
                  Qualsiasi operazione o insieme di operazioni, compiute con o
                  senza l'ausilio di processi automatizzati e applicate a dati
                  personali o insiemi di dati personali. Un trattamento
                  legittimo è basato su fondamenti normativi solidi e ben
                  definiti.
                </p>
              </div>
            </div>
          </section>

          {/* Principi GDPR */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Principi Applicabili al Trattamento
            </h2>
            <p style={{ marginBottom: '20px' }}>
              Affinché il trattamento dei dati personali sia conforme alla
              Normativa europea e domestica deve rispettare i seguenti principi:
            </p>
            <div style={{ display: 'grid', gap: '15px' }}>
              {[
                {
                  title: 'Liceità, Correttezza e Trasparenza',
                  desc: "La liceità implica che il trattamento sia sorretto dalle basi giuridiche definite dagli artt. 6 e 9 del Regolamento; la correttezza si riferisce a una condotta di lealtà e buona fede; la trasparenza garantisce la piena consapevolezza dell'interessato.",
                },
                {
                  title: 'Limitazione delle Finalità',
                  desc: 'È la garanzia che i dati saranno trattati solo ed esclusivamente per il conseguimento delle finalità per cui sono stati raccolti.',
                },
                {
                  title: 'Minimizzazione dei Dati',
                  desc: 'Vengono trattati solo i dati necessari al conseguimento delle finalità specifiche.',
                },
                {
                  title: 'Limitazione della Conservazione',
                  desc: 'I dati saranno conservati per un arco di tempo necessario al conseguimento delle finalità e secondo i requisiti normativi marittimi.',
                },
              ].map((principle, index) => (
                <div
                  key={index}
                  style={{
                    background: '#e6f3ff',
                    padding: '15px',
                    borderRadius: '8px',
                    border: '1px solid #b3d9ff',
                  }}
                >
                  <h4 style={{ color: '#1e3c72', marginBottom: '8px' }}>
                    {principle.title}
                  </h4>
                  <p style={{ margin: 0, fontSize: '0.95rem' }}>
                    {principle.desc}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* Accountability */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Il Principio di Accountability
            </h2>
            <div
              style={{
                background: '#f0f8ff',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #bde0ff',
              }}
            >
              <p>
                Secondo questo principio di Accountability
                (=responsabilizzazione) la compliance privacy di natura
                preventiva è una delle chiavi di volta del GDPR. Il titolare del
                trattamento deve essere in grado di dar prova di avere adottato
                delle misure - da quelle giuridiche a quelle
                tecnico-organizzative - volte a garanzia dei dati personali
                degli interessati.
              </p>
              <p style={{ marginTop: '15px' }}>
                <strong>Il Registro del Trattamento:</strong> Documento previsto
                dall'art. 30 GDPR, redatto in forma scritta per registrare tutte
                le attività trattamentali poste in essere dal Titolare,
                rappresentando uno strumento per verificare il grado di
                accountability.
              </p>
            </div>
          </section>

          {/* Data Breach */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Data Breach e Procedure di Emergenza
            </h2>
            <div
              style={{
                background: '#fff5f5',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #fed7d7',
              }}
            >
              <p>
                Il Regolamento si poggia su una logica di carattere proattivo.
                In caso di violazione dei dati personali, è prevista una
                procedura che prevede che il Titolare del trattamento senza
                ingiustificato ritardo e, ove possibile, entro 72 ore dal
                momento in cui ne è venuto a conoscenza, deve notificare la
                violazione al Garante.
              </p>
              <p style={{ marginTop: '15px' }}>
                Particolare attenzione nel settore marittimo deve essere posta
                alla tipologia di sinistro privacy e all'impatto sui diritti e
                le libertà degli interessati, considerando le specifiche
                condizioni operative delle imbarcazioni.
              </p>
            </div>
          </section>

          {/* Misure di Sicurezza Avanzate */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Misure di Sicurezza Tecniche e Organizzative
            </h2>
            <div
              style={{
                background: '#e8f5e8',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #c3e6c3',
                marginBottom: '20px',
              }}
            >
              <p>
                All'interno del Regolamento è previsto che il Titolare e il
                Responsabile del Trattamento adottino misure tecniche e
                organizzative adeguate a garantire un livello di sicurezza
                adeguato al rischio derivante dal trattamento. L'adozione di
                dette misure deve essere in grado di assicurare la riservatezza,
                l'integrità e la disponibilità dei dati trattati.
              </p>
            </div>

            <div style={{ display: 'grid', gap: '15px' }}>
              <div
                style={{
                  background: '#f0f8ff',
                  padding: '15px',
                  borderRadius: '8px',
                  border: '1px solid #bde0ff',
                }}
              >
                <h4 style={{ color: '#1e3c72', marginBottom: '8px' }}>
                  Pseudonimizzazione
                </h4>
                <p style={{ margin: 0, fontSize: '0.95rem' }}>
                  Tecnica che permette di mascherare il dato, sostituendo le
                  informazioni identificative con indicatori generati mediante
                  algoritmi, rendendo i dati meno riconducibili alla persona
                  fisica.
                </p>
              </div>
              <div
                style={{
                  background: '#f0f8ff',
                  padding: '15px',
                  borderRadius: '8px',
                  border: '1px solid #bde0ff',
                }}
              >
                <h4 style={{ color: '#1e3c72', marginBottom: '8px' }}>
                  Cifratura e Crittografia
                </h4>
                <p style={{ margin: 0, fontSize: '0.95rem' }}>
                  Procedura che rende il dato indecifrabile, utilizzando chiavi
                  di conversione simmetriche o asimmetriche. Solo chi possiede
                  la chiave corretta può accedere ai dati in chiaro.
                </p>
              </div>
            </div>
          </section>

          {/* Data Protection Officer */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Data Protection Officer (DPO)
            </h2>
            <div
              style={{
                background: '#f3e5f5',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #ce93d8',
              }}
            >
              <p>
                Il Data Protection Officer (DPO), in italiano Responsabile per
                la protezione dei dati personali, è la figura che deve essere
                obbligatoriamente designata dal Titolare del trattamento ai
                sensi dell'art. 37 GDPR in specifiche circostanze.
              </p>
              <p style={{ marginTop: '15px' }}>
                <strong>Compiti principali del DPO:</strong>
              </p>
              <ul style={{ marginTop: '10px' }}>
                <li>
                  Informare il titolare e fornire consulenza specialistica
                </li>
                <li>
                  Sorvegliare l'osservanza del GDPR e delle normative correlate
                </li>
                <li>
                  Fornire pareri in merito alla DPIA (Data Protection Impact
                  Assessment)
                </li>
                <li>
                  Cooperare con l'autorità di controllo come punto di contatto
                </li>
                <li>Garantire autonomia funzionale e indipendenza operativa</li>
              </ul>
            </div>
          </section>

          {/* Informazioni Privacy Stratificate */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Informazioni Privacy e Trasparenza
            </h2>
            <div
              style={{
                background: '#fffbf0',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #ffe066',
              }}
            >
              <p>
                Nell'ottica della più totale trasparenza, il Regolamento prevede
                che l'interessato debba avere la piena consapevolezza delle
                attività trattamentali effettuate sui propri dati. Gli articoli
                13 e 14 del GDPR stabiliscono il contenuto minimo delle
                informazioni da fornire in maniera chiara, intelligibile e
                facilmente accessibile.
              </p>
              <div style={{ marginTop: '20px' }}>
                <h4 style={{ color: '#d69e2e', marginBottom: '10px' }}>
                  Contenuti minimi obbligatori:
                </h4>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '10px',
                    marginTop: '15px',
                  }}
                >
                  {[
                    'Dati di contatto del Titolare',
                    'Dati di contatto del DPO-RPD',
                    'Base giuridica del trattamento',
                    'Periodo di conservazione',
                    "Diritti dell'interessato",
                    'Trasferimenti in Paesi terzi',
                  ].map((item, index) => (
                    <div
                      key={index}
                      style={{
                        background: 'rgba(255, 224, 102, 0.3)',
                        padding: '8px 12px',
                        borderRadius: '5px',
                        fontSize: '0.9rem',
                        textAlign: 'center',
                        fontWeight: '500',
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>
              <p style={{ marginTop: '20px', fontSize: '0.95rem' }}>
                <strong>Principio di stratificazione:</strong> Le informazioni
                privacy possono essere fornite con modalità alternative
                (grafiche, audio, video) purché rispettino i principi normativi
                e le linee guida del Garante.
              </p>
            </div>
          </section>

          {/* Facoltatività Conferimento */}
          <section style={{ marginBottom: '40px' }}>
            <h2
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: '#1e3c72',
                marginBottom: '20px',
              }}
            >
              Facoltatività del Conferimento dei Dati
            </h2>
            <div
              style={{
                background: '#e6f7ff',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #91d5ff',
              }}
            >
              <p>
                A parte quanto specificato per i dati di navigazione, l'utente è
                libero di fornire i dati personali riportati nei moduli
                dell'applicazione o indicati per le comunicazioni con il
                supporto tecnico. Il loro mancato conferimento può comportare
                l'impossibilità di ottenere quanto richiesto o di utilizzare
                specifiche funzionalità dell'app.
              </p>
              <p style={{ marginTop: '15px' }}>
                <strong>Consenso al trattamento:</strong> L'utente è libero di
                fornire i propri dati personali attraverso l'utilizzo
                dell'applicazione. Per quanto riguarda l'utilizzo dell'app, non
                è richiesta la comunicazione di dati personali specifici oltre
                quelli necessari per le funzionalità operative, ma implica la
                rilevazione di dati anonimi di navigazione e utilizzo.
              </p>
            </div>
          </section>

          {/* Sezione Finale di Riepilogo */}
          <section style={{ marginBottom: '40px' }}>
            <div
              style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
              }}
            >
              <h2 style={{ fontSize: '2rem', marginBottom: '15px' }}>
                Riepilogo Diritti e Garanzie
              </h2>
              <p
                style={{
                  fontSize: '1.1rem',
                  opacity: 0.9,
                  marginBottom: '20px',
                }}
              >
                CrewBoat garantisce il massimo rispetto della privacy nel
                settore delle operazioni marittime
              </p>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                  gap: '20px',
                  marginTop: '25px',
                }}
              >
                <div
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    padding: '20px',
                    borderRadius: '10px',
                    textAlign: 'left',
                  }}
                >
                  <h4 style={{ marginBottom: '10px' }}>
                    🔒 Sicurezza Garantita
                  </h4>
                  <p style={{ fontSize: '0.9rem', opacity: 0.9, margin: 0 }}>
                    Crittografia AES-256, backup automatici, controlli di
                    accesso granulari per la massima protezione dei dati
                    dell'equipaggio.
                  </p>
                </div>
                <div
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    padding: '20px',
                    borderRadius: '10px',
                    textAlign: 'left',
                  }}
                >
                  <h4 style={{ marginBottom: '10px' }}>⚖️ Conformità GDPR</h4>
                  <p style={{ fontSize: '0.9rem', opacity: 0.9, margin: 0 }}>
                    Pieno rispetto del Regolamento Europeo 679/2016 e del Codice
                    Privacy italiano, con tutti i diritti garantiti.
                  </p>
                </div>
                <div
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    padding: '20px',
                    borderRadius: '10px',
                    textAlign: 'left',
                  }}
                >
                  <h4 style={{ marginBottom: '10px' }}>
                    ⚓ Normative Marittime
                  </h4>
                  <p style={{ fontSize: '0.9rem', opacity: 0.9, margin: 0 }}>
                    Conformità alle convenzioni internazionali IMO: SOLAS,
                    MARPOL, STCW, MLC 2006, ISM e ISPS Code.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Nota Conclusiva */}
          <section style={{ marginBottom: '20px' }}>
            <div
              style={{
                background: '#f8f9fa',
                padding: '25px',
                borderRadius: '10px',
                border: '1px solid #e9ecef',
                textAlign: 'center',
              }}
            >
              <p style={{ fontSize: '1rem', marginBottom: '10px' }}>
                <strong>
                  Questa informativa sulla privacy è stata redatta per garantire
                  la massima trasparenza nel trattamento dei dati personali
                  secondo le normative europee e le specifiche esigenze del
                  settore marittimo.
                </strong>
              </p>
              <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>
                Per qualsiasi dubbio o richiesta di chiarimento, non esitare a
                contattare il Titolare del trattamento all'indirizzo{' '}
                <strong>vmdpproject@gmail.com</strong>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
    </div>
  );
};

export default CrewBoatPrivacyPolicy;
